var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-nav"},[_c('static-banner',{attrs:{"image_banner":_vm.image_banner,"main-title":"园区资讯","sub-title":"以下是园区的最新动态"}}),_c('NewsContent',{attrs:{"news-type":"4","content-title":"园区资讯"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }